import React, { useEffect } from "react";
import { Task } from "../types/Task";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { Eye, Trash } from "lucide-react";
import { Project } from "../types/Project";
import { fetchProjects } from "../redux/actions/projectAction";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import "../styles/EmployeeList.css";

interface Props {
  taskList: Task[];

  onEdit: (task: Task) => void;
  onView: (task: Task) => void;
  onDelete: (id: number) => void;
  projectList?: Project[];
}

export const getProject = (projectId: number, projects: Project[]): string => {
  const project = projects.find((p) => p.id === projectId);
  return project ? project.name : "Unknown";
};

const TaskList: React.FC<Props> = ({
  taskList,
  onEdit,
  onDelete,
  onView,
  projectList,
}) => {
  const dispatch = useDispatch<any>();
  const projects = useSelector((state: StoreState) => state.project);

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  const allProjects = projectList || projects || [];

  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View details</Popover.Body>
    </Popover>
  );

  return (
    <div className="table-responsive">
      <Table className="custom-employee-table" responsive>
        <thead>
          <tr>
            <th rowSpan={2}>Title</th>
            <th rowSpan={2}>Status</th>
            <th colSpan={3} className="text-center">
              Estimated Hours
            </th>
            <th colSpan={3} className="text-center">
              Actual Hours
            </th>
            <th colSpan={3} className="text-center">
              Assigned
            </th>
            <th rowSpan={2}>Action</th>
          </tr>
          <tr>
            <th className="sub">Dev</th>
            <th className="sub">QA</th>
            <th className="sub">BA</th>
            <th className="sub">Dev</th>
            <th className="sub">QA</th>
            <th className="sub">BA</th>
            <th className="sub">Dev</th>
            <th className="sub">QA</th>
            <th className="sub">BA</th>
          </tr>
        </thead>
        <tbody>
          {taskList.map((task) => (
            <tr key={task.id}>
              {/* <td>{getProject(task.projectId, allProjects)}</td> */}
              <td>{task.title}</td>
              {/* <td><div dangerouslySetInnerHTML={{ __html: task.description }} />
             </td> */}
              <td>{task.status}</td>
              <td>{task.devEstHrs}</td>
              <td>{task.devActHrs}</td>
              <td>{task.qaEstHrs}</td>
              <td>{task.qaActHrs}</td>
              <td>{task.baEstHrs}</td>
              <td>{task.baActHrs}</td>
              <td>{task.assignedDev}</td>
              <td>{task.assignedQa}</td>
              <td>{task.assignedBa}</td>
              <td className="d-flex no-wrap border-0">
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={viewPopover}
                >
                  <Button
                    className="btn btn-sm text-white"
                    style={{
                      backgroundColor: "#10296C",
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onView(task)}
                  >
                    <Eye style={{ width: "20px" }} />
                  </Button>
                </OverlayTrigger>
                <Button
                  variant="danger"
                  onClick={() => onDelete(task.id)}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <Trash />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TaskList;
